<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path fill="#fca2af" d="M370.4 50H462c12.6 0 22.9 10.2 22.9 22.9v366.2c0 12.6-10.2 22.9-22.9 22.9h-91.5V50z" />
      <path fill="#f05264" d="M46.8 47.2 334.5 6.1c3.3-.5 6.6.5 9.1 2.7s3.9 5.3 3.9 8.6v477.1c0 3.3-1.4 6.5-3.9 8.6-2.5 2.2-5.8 3.2-9.1 2.7l-287.7-41c-11.3-1.6-19.7-11.3-19.7-22.7V69.9c0-11.4 8.4-21.1 19.7-22.7z" />
      <path fill="#fff" d="M107.4 361.6V150.1c0-3.3 1.2-6.1 3.7-8.4 2.5-2.3 5.5-3.4 9.1-3.4h70.3c14.3 0 27.4 3.4 39.2 10.2 11.8 6.8 21 15.9 27.6 27.2 6.6 11.4 9.9 23.3 9.9 35.9 0 13.2-2.9 25.4-8.7 36.5-5.8 11.1-14.5 20.1-26.1 26.9-11.6 6.8-25.5 10.2-41.9 10.2h-57.2v76.2c0 3.3-1.3 6.1-3.9 8.5-2.6 2.4-5.7 3.6-9.2 3.6-3.6 0-6.6-1.2-9.1-3.6-2.4-2.2-3.7-5-3.7-8.3zm76.7-97.2c17.3 0 31.1-4.2 41.5-12.7 10.4-8.5 15.6-21.8 15.6-39.9 0-12-2.8-21.9-8.4-29.9-5.6-7.9-12.7-13.7-21.4-17.3-8.6-3.6-17.8-5.4-27.4-5.4h-50.8v105.3h50.9z" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
